export default __webpack_public_path__ + "static/media/google.cd4c39f1.jpg";